import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { Outlet } from "react-router-dom";
import TopBar from "../../components/Headers/TopBar";
import Navbar from "../../components/Headers/Navbar";
import Footer from "../../components/Footer/Footer";
import ScrollToTop from "../../components/ScrollTo/ScrollToTop";

const HomePage = () => {
  return (
    <Grid
      container
      flexDirection="column"
      alignContent="flex-start"
      justifyContent="flex-start"
      style={{ width: "100%", minHeight: "100vh" }}
    >
      <ScrollToTop />
      <TopBar />
      <Navbar />
      <main
        style={{
          // flexGrow: 1,
          maxWidth: "100%",
        }}
      >
        <Outlet />
      </main>
      <Footer />
    </Grid>
  );
};

export default HomePage;
